import { upstreamApi } from '../upstreamApi';
import { asyncAction } from './asyncAction';
// import { AppState } from '../reducers';
// import { GET_DOWNLOAD_TOKEN, READ_SERVER } from './actionTypes';
import { READ_SERVER } from './actionTypes';

export function readDataExport(storeIdentifier: string, id: string | number) {
  return asyncAction({
    actionType: READ_SERVER,
    func: async () => (await upstreamApi.dataExports.get(id)).data,
    storeIdentifier,
  });
}

export function updateDataExport(storeIdentifier: string, id: string | number, updatedAt: Date | string, patch: any) {
  return asyncAction({
    actionType: READ_SERVER,
    func: async () => (await upstreamApi.dataExports.patch(id, updatedAt, patch)).data,
    storeIdentifier,
  });
}

